/** Shared token-based class names for forms, buttons and cards in the app shell (light/dark via CSS tokens) */

export const inputClass =
  'w-full rounded-md border border-border bg-surface px-3 py-2 text-base text-fg placeholder:text-fg-subtle focus:border-accent focus:outline-none focus:ring-1 focus:ring-accent disabled:cursor-not-allowed disabled:opacity-60 md:text-sm'

export const labelClass = 'block text-sm font-medium text-fg-muted'

export const hintClass = 'text-xs text-fg-subtle'

export const buttonPrimaryClass =
  'inline-flex min-h-9 cursor-pointer items-center justify-center gap-1.5 rounded-md bg-accent px-3 py-2 text-sm font-semibold text-accent-fg hover:bg-accent-hover disabled:cursor-not-allowed disabled:opacity-60'

export const buttonSecondaryClass =
  'inline-flex min-h-9 cursor-pointer items-center justify-center gap-1.5 rounded-md border border-border px-3 py-2 text-sm font-medium text-fg-muted hover:bg-surface-hover hover:text-fg disabled:cursor-not-allowed disabled:opacity-60'

export const buttonDangerClass =
  'inline-flex min-h-9 cursor-pointer items-center justify-center gap-1.5 rounded-md border border-danger/30 px-3 py-2 text-sm font-medium text-danger hover:bg-danger-soft disabled:cursor-not-allowed disabled:opacity-60'

export const iconButtonClass =
  'inline-flex h-9 w-9 shrink-0 cursor-pointer items-center justify-center rounded-md text-fg-subtle hover:bg-surface-hover hover:text-fg disabled:cursor-not-allowed disabled:opacity-60'

export const cardClass = 'rounded-lg border border-border bg-surface-raised'

export const badgeClass = 'inline-flex items-center rounded-md border border-border px-1.5 py-0.5 text-xs text-fg-subtle'

export const errorTextClass = 'rounded-md border border-danger/30 bg-danger-soft px-3 py-2 text-sm text-danger'
